import { init } from './init';

export { trackEvent } from './track-event';
export type { WixAnalytics } from './types';

init();
